// extracted by mini-css-extract-plugin
export default {"WelcomeContainer":"welcome_WelcomeContainer__lHYRM","WelcomeInfo":"welcome_WelcomeInfo__ifAVF","actionBtn":"welcome_actionBtn__Tdttq","wave":"welcome_wave__lgTJx"};